export default __webpack_public_path__ + "static/media/uncertaintyRockMassUnit.8b431d4f.png";